import React from 'react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { useTranslation } from 'react-i18next';
import useThumbnailUrl from '../../hooks/useThumbnailUrl';
import PRODUCT_TYPES from '../../constants/productTypes';
import PAYMENT_TYPES from '../../constants/paymentTypes';

// Day.js Timezone 관련 플러그인 활성화
dayjs.extend(utc);
dayjs.extend(timezone);

const PurchaseCard = ({ item }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { product_id, product_type, currency } = item;
  const imageUrl = useThumbnailUrl(item.thumbnail_info, 96);

  // 접속 국가에 따른 타임존 설정
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const handleClickCard = (product_type, product_id) => {
    if (product_type === PRODUCT_TYPES.VIDEO) {
      navigate(`/product-video-detail/${product_id}`);
    } else if (product_type === PRODUCT_TYPES.DIGITAL) {
      navigate(`/product-digital-detail/${product_id}`);
    }
  };

  return (
    <div
      className={`purchase-card table-layout-wrapper ${
        product_type === PRODUCT_TYPES.DIGITAL ? 'type-digital-card' : ''
      }`}
    >
      <div className='purchase-left-wrapper table-layout-left-wrapper'>
        <div className='purchase-info-group'>
          <figure
            className='purchase-img-group cursor-pointer'
            onClick={() => {
              handleClickCard(product_type, product_id);
            }}
          >
            <img
              src={imageUrl || '/img_no_img.png'}
              alt='product thumbnail'
              className={'purchase-img'}
              width='96'
              height='96'
              onError={(e) => {
                e.target.onerror = null; // onError 이미지도 실패했을 때 무한루프 방지
                e.target.src = '/img_no_img.png';
              }}
              decoding={'async'}
            />
          </figure>
          <div className='purchase-txt-group'>
            <p className={'purchase-title'}>{item.title}</p>
            {item.email ? (
              <p className={'purchase-info'}>
                {t('email')}: {item.email}
              </p>
            ) : null}
            {/* 디지털 상품: 옵션 */}
            {product_type === PRODUCT_TYPES.DIGITAL && item.item ? (
              <p className={'purchase-info'}>
                {t('options')}: {item.item}
              </p>
            ) : null}
            {/* 구매자 정보 */}
            {item.consumer_info ? (
              <p className={'purchase-info'}>
                {t('purchaser_information')}: {item.consumer_info}
              </p>
            ) : null}
            {/* 비디오 상품: 시청 기한 */}
            {product_type === PRODUCT_TYPES.VIDEO && item.end_at ? (
              <p className={'purchase-info'}>
                {t('service_period')}: {dayjs(item.end_at).format('YYYY. MM. DD HH:mm')}
              </p>
            ) : null}
          </div>
        </div>
      </div>
      <div className='purchase-right-wrapper table-layout-right-wrapper'>
        <div className='purchase-info-group table-layout-center table-layout-content-group mb-hide'>
          <span className={'purchase-info-txt'}>{dayjs(item.buy_at).tz(timezone).format('YYYY. MM. DD')}</span>
        </div>
        <div className='purchase-info-group table-layout-center table-layout-content-group table-flex-start'>
          <span className={'mobile-purchase-label-txt mb-show'}>Quantity : </span>
          <span className={'purchase-info-txt'}>
            <span className={'mb-show'} />
            {/* 비디오 상품의 경우 별도의 amount가 없음, 수량 1개 */}
            {item.amount ? item.amount : 1}
          </span>
        </div>
        <div className='purchase-info-group table-layout-center table-layout-content-group table-flex-end'>
          {currency !== PAYMENT_TYPES.STAR_BEAT ? (
            <span className={'purchase-info-txt purchase-info-price-txt'}>
              {item.price?.toLocaleString()}&nbsp;{item?.currency}
            </span>
          ) : null}
          {currency === PAYMENT_TYPES.STAR_BEAT ? (
            <span className={'purchase-info-txt purchase-info-price-txt'}>
              <span className={'star-point-group'}>
                <i className={'icon icon-star-point'} />
              </span>
              {item.price?.toLocaleString()}
            </span>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default PurchaseCard;
